<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取人员组人员列表</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			person_list接口提供了获取人员组下全部人员列表的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/person_list">https://skfrm.cn/APIV2/person_list</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters-new :propsTableData="frmRequestParamsNew"></frm-Request-parameters-new>
		<!--<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>-->
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
			"data":
			[
				{
					"person_id":"284747",
					"person_name":"王子健",
					"recognition_time":"2018-12-17 11:11:21",
					"date":"2018-12-17 11:11:21",
					"image_url":"http://192.168.135.19/Uploads/image/2018-09-11/head_1536636397956.jpg",
					"image_url_small":"http://192.168.135.19/Uploads/image/2018-09-11/head_1536636397956.jpg",
					"terminal_name":"新终端",
					"gender":"1",
					"birth":"1993-12-23",
					"age":25,
				}
			],
		"person_number":"1",
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
	import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
	import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	import FrmRequestParamsTableNew from '../../../../components/frmRequestParamsTableNew';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,		
			'frm-Request-parameters':FrmRequestParamsTable,		
			'frm-Return-Value-New':FrmReturnValueTableNew,
			'frm-Error-Code':FrmErrorCodeTable, 
			'frm-Request-parameters-new':FrmRequestParamsTableNew,

		},
		data(){
			return{
				isPathData:['FRM API-v2','人员管理','获取人员组人员列表'],
				
				frmRequestParamsNew:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id","rowspan":1,"colspan":1},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token","rowspan":1,"colspan":1},
					{"require":"是","name":"project_id","type":"int","msg":"项目id","rowspan":1,"colspan":1},
					{"require":"是","name":"group_id","type":"int","msg":"要获取的人员组id","rowspan":1,"colspan":1},
					{"require":"否","name":"page","type":"int","msg":"人员列表页索引，（注：每页100人），索引值从1开始","rowspan":1,"colspan":1},
					
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"排序方式",
						"rowspan":13,
						"colspan":1,
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按修改时间正序date_asc",
						
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按修改时间倒序date_desc",
						
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按识别时间正序recognition_time_asc",
						
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按识别时间倒序recognition_time_desc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按姓名正序name_asc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按姓名倒序name_desc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按终端名正序terminal_asc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按终端名倒序terminal_desc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按年龄正序age_asc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按年龄倒序age_desc",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按性别gender_asc（先女后男）",
					},
					{
						"require":"否",
						"name":"sort",
						"type":"string",
						"msg":"按性别gender_desc（先男后女）",
					},
				],
				frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"person_number",
						"name":"string",
						"msg":"当前人员组下的总人数",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"人员信息数组",
						"rowspan":11,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"person_id   string     人员id",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"person_name   string     人员姓名",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"gender   string     人员性别 1女  2 男",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"birth   string     人员出生日期",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"image_url   string     人员头像URL",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"image_url_small   string     人员头像缩略图URL",
					},
					{
						"Parameter":"date",
						"name":"string",
						"msg":"date   string     人员修改时间",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"recognition_time  string  最后一次识别该人员的时间",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"terminal_name  string  最后一次识别该人员的终端",
					},
					{
						"Parameter":"data",
						"name":"string",
						"msg":"age     string    年龄",
					},
			
				],
				frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"3003","errormessage":"group_id无效","msg":"人员组不存在"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Personnelmanagement/Personnellist.vue